const getCookie = cookieKey => {
  let cookieObj = {};
  const cookieArr = document.cookie.split(';');
  cookieArr.forEach(cookie => {
    const [key, val] = cookie.split('=');
    cookieObj = { ...cookieObj, [key]: val };
  });
  const { [cookieKey]: cookie } = cookieObj;
  return cookie || null;
};

const setCookie = (key, val) => (document.cookie = `${key}=${val}; expires=;`);

const removeCookie = cookieKey =>
  (document.cookie = `${cookieKey}=; expires=0;`);

const isAFunction = fn => typeof fn === 'function';

const getStorage = () => {
  const { localStorage, sessionStorage } = window;
  const {
    setItem: localSetItem,
    getItem: localGetItem,
    removeItem: localRemoveItem,
  } = localStorage;
  if (
    isAFunction(localSetItem) &&
    isAFunction(localGetItem) &&
    isAFunction(localRemoveItem)
  ) {
    return localStorage;
  }
  const {
    setItem: sessionSetItem,
    getItem: sessionGetItem,
    removeItem: sessionRemoveItem,
  } = localStorage;
  if (
    isAFunction(sessionSetItem) &&
    isAFunction(sessionGetItem) &&
    isAFunction(sessionRemoveItem)
  ) {
    return sessionStorage;
  }
  return {
    getItem: getCookie,
    setItem: setCookie,
    removeItem: removeCookie,
  };
};

export default getStorage;
